import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("hesttya_token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        if (payload.exp * 1000 < Date.now()) {
          logout();
        } else {
          // Try to restore full user data saved at login time
          const saved = localStorage.getItem("hesttya_user");
          if (saved) {
            setUser(JSON.parse(saved));
          } else {
            setUser({ id: payload.sub, role: payload.role, id_consultor: payload.id_consultor, pais: payload.pais || "es" });
          }
        }
      } catch {
        logout();
      }
    }
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const login = (tokenStr, userData) => {
    localStorage.setItem("hesttya_token", tokenStr);
    localStorage.setItem("hesttya_user", JSON.stringify(userData));
    setToken(tokenStr);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("hesttya_token");
    localStorage.removeItem("hesttya_user");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        login,
        logout,
        loading,
        isSuperadmin: user?.role === "superadmin",
        isAdmin: user?.role === "admin",
        isMarketing: user?.role === "marketing",
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
